function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M98.124 46.218c-.897 0-1.598.702-1.598 1.599v16.297H24.125V47.817c0-.897-.702-1.599-1.599-1.599-.896 0-1.598.702-1.598 1.599v16.96a2.53 2.53 0 002.534 2.534h73.765a2.53 2.53 0 002.535-2.534v-16.96c-.04-.897-.741-1.599-1.638-1.599zM97.228 19.784H23.462a2.53 2.53 0 00-2.534 2.534v16.96c0 .897.702 1.599 1.599 1.599.896 0 1.598-.702 1.598-1.599V22.981h72.362v16.297c0 .897.702 1.599 1.599 1.599.896 0 1.598-.702 1.598-1.599v-16.96a2.464 2.464 0 00-2.456-2.534z",
  fill: "#00BAC3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M102.219 13H18.434A6.44 6.44 0 0012 19.433v53.18c0 .897.741 1.598 1.599 1.598h93.454c.897 0 1.599-.74 1.599-1.598v-53.18c.039-3.548-2.885-6.433-6.433-6.433zm3.236 57.975H15.198v-51.58a3.228 3.228 0 013.235-3.237h83.786a3.228 3.228 0 013.236 3.236v51.581z",
  fill: "#384B51"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M107.053 70.976H13.599c-.897 0-1.599.74-1.599 1.599v8.07a6.44 6.44 0 006.433 6.433h83.785a6.44 6.44 0 006.433-6.433v-8.07c.039-.858-.701-1.599-1.598-1.599zm-1.599 9.67a3.228 3.228 0 01-3.236 3.235H18.433a3.228 3.228 0 01-3.236-3.236v-6.433h90.257v6.433z",
  fill: "#384B51"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M65.18 77.447h-9.67c-.896 0-1.598.741-1.598 1.599 0 .896.74 1.598 1.599 1.598h9.669c.896 0 1.598-.74 1.598-1.598 0-.897-.74-1.599-1.598-1.599zM81.282 96.786H39.37c-2.651 0-4.834 2.183-4.834 4.834s2.183 4.835 4.834 4.835h41.912c2.651 0 4.835-2.184 4.835-4.835a4.834 4.834 0 00-4.835-4.834zm0 6.433H39.37a1.606 1.606 0 01-1.598-1.599c0-.897.74-1.598 1.598-1.598h41.912c.897 0 1.599.74 1.599 1.598 0 .858-.702 1.599-1.599 1.599z",
  fill: "#384B51"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M78.046 96.785c-5.341 0-8.07-3.781-8.07-11.267 0-.897-.741-1.599-1.599-1.599H52.275c-.897 0-1.599.741-1.599 1.599 0 7.486-2.729 11.267-8.07 11.267-.897 0-1.599.741-1.599 1.599 0 .897.741 1.599 1.599 1.599h35.44c.897 0 1.598-.741 1.598-1.599.04-.897-.701-1.599-1.598-1.599zm-27.604 0c1.989-2.183 3.158-5.458 3.392-9.668h12.983c.234 4.21 1.404 7.485 3.392 9.668H50.442z",
  fill: "#384B51"
});

function SvgDesktop(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgDesktop;